import {
    CartModel,
    Edp,
    Insurance,
    Option,
    Product,
    ProductFactory,
    PromotionModel,
    QuoteModel,
} from '@bytel/bytel-sales';
import { CheckoutCartModel, QuoteContextRenewalModel, WithoutContext } from '@bytel/checkout';

import { SHIPPING_MODES } from '@base/common/constants/index';

export class SalesApiHelper {
    public static readonly InternalProductGencode: string[] = [
        'delivery',
        'EPD0000000',
        ...Object.values(SHIPPING_MODES),
    ];

    public static IsCompatibleWithPromotions(product: Product): boolean {
        switch (true) {
            case ProductFactory.Is(product, Option):
            case ProductFactory.Is(product, Insurance):
                return false;
            default:
                return true;
        }
    }

    public static GetCartGenericParams(cart: CartModel, gencodes: string[] = []): WithoutContext {
        const quote: QuoteModel = cart.getQuote();
        quote.products.forEach((product) => {
            if (SalesApiHelper.IsApiProduct(product)) {
                gencodes.push(product.gencode);
            }
        });
        const params: WithoutContext = {
            typeParcours: cart.getQuote().context.id,
            typeClient: cart.getCustomerCategory(),
            edp: !!quote.getProductsByType(Edp).length,
            gencodes,
            noPersonne: (cart as CheckoutCartModel)?.userId,
        };

        if (quote.isRenewal()) {
            params.contractId = (quote.context as QuoteContextRenewalModel).contractId.toString();
        }

        const coupon: PromotionModel = cart.promotions.coupon;
        if (coupon) {
            params.coupon = coupon.code;
        }

        const shipping = quote.address.shipping;
        if (shipping?.codePostal) {
            params.adresse = { codePostal: shipping.codePostal };
        }

        return params;
    }

    public static IsApiProduct(product: string | Product): boolean {
        if (product instanceof Product) {
            product = product.gencode;
        }
        return !SalesApiHelper.InternalProductGencode.some((gencode) => product === gencode);
    }
}
